export const PublishingStatus = {
  ERROR: "ERROR",
  PUBLISHED: "PUBLISHED",
  UNHANDLED_ERROR: "UNHANDLED_ERROR",
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  HIDDEN: "HIDDEN"
}

